import { useState } from "react";
import { FiLoader } from "react-icons/fi";
import { lessonPlayback } from "../utils/lessonPlayback.mjs";
import LessonVideo from "./LessonVideo";
import VideoPlayer from "./VideoPlayer";

export default function ClassPlayback({ lesson, apiUrl, trackProgress, completed, onProgress, accountId, savedProgress }) {
  const [pinned, setPinned] = useState(null);
  const [mp4Failed, setMp4Failed] = useState(false);
  const current = lessonPlayback(lesson, apiUrl, !mp4Failed);
  // Keep an already-started MP4 mounted when a background HLS refresh arrives.
  const playback = pinned && lesson.mp4Fallback?.sourceId === pinned.sourceId ? pinned : current;
  if (playback.src) {
    const events = {
      positionKey: accountId ? JSON.stringify([accountId, lesson._id, playback.progressSource]) : undefined,
      initialPosition: savedProgress?.videoUrl === playback.progressSource ? savedProgress.lastPositionSeconds : 0,
      onPlay: () => { if (playback.fallback && !pinned) setPinned({ ...playback, sourceId: lesson.mp4Fallback.sourceId }); },
      onError: () => { if (playback.fallback) { setPinned(null); setMp4Failed(true); } },
    };
    return trackProgress
      ? <LessonVideo key={playback.src} {...playback} {...events} title={lesson.title} completed={completed} onProgress={onProgress} />
      : <VideoPlayer key={playback.src} {...playback} {...events} title={lesson.title} poster={lesson.thumbnail} />;
  }
  if (!playback.processing && !playback.failed) return null;
  return <div role="status" className="flex aspect-video items-center justify-center gap-2 bg-gray-100 p-4 text-sm font-medium text-gray-700">
    {playback.failed ? "Video processing failed. Please contact the channel owner." : <><FiLoader className="animate-spin" />Video processing...</>}
  </div>;
}
